export default __webpack_public_path__ + "static/4-580b52728abf6f5333aff69eaccd9982.png";